// extracted by mini-css-extract-plugin
export default {"main":"card_main__NIjXP","container":"card_container__BS0iQ","flex60":"card_flex60__ePX6F","flex40":"card_flex40__cDWcQ"};